module.exports = __webpack_public_path__ + "static/media/cabo-de-santo-agostinho-pe.f9ed21ef.jpg";